import {store} from "@/store";
import {api, getSelectedEnvironment} from "@/plugins/api_conect";
import Vue from "vue";

const auth = {
    async refreshToken() {
        const currentEnvironment = getSelectedEnvironment();
        let tokenExpiryDate = store.getters.tokensExpiry;
        const now = new Date();
        if (new Date(tokenExpiryDate) < now) {
            this.logout();
        } else {
            let datos = {
                grant_type: "refresh_token",
                client_id: currentEnvironment.client_id,
                client_secret: currentEnvironment.client_secret,
                refresh_token: localStorage.getItem('refresh_token')
            };
            try {
                const response = await api().post(`/oauth/token`, datos, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*"
                    },
                });
                const { data } = response;
                localStorage.access_token = data.access_token;
                localStorage.refresh_token = data.refresh_token;
                localStorage.token_type = data.token_type;

                store.commit("update_auth_tokens", data);
            } catch (error) {
                this.logout()
                await Vue.prototype.$swal("Error", "Ocurrio un error", "error");
            }
        }
    },
    logout() {
        console.log("logging out"); // Commit the mutation to clear Vuex state
        localStorage.clear()
        sessionStorage.clear()
        store.commit('logout');
        
        // Add a small delay to ensure logs are printed and storage operations complete
        // before the page unloads
        setTimeout(() => {
             window.location.href = `${process.env.VUE_APP_URL}/`;
             window.location.reload();
        }, 100);
    }

}
export default auth